// import React, { useState, useEffect } from "react";
// import { Spin, Steps, Typography } from "antd";
// import "../../../assets/dist/ConsumerProject/Consumer/ConsumerPreview.css";
// import _consumerService from "../../../modules/consumerService";
// import ApplicationWorkFlow from "./ApplicationWorkFlow";
// const { Step } = Steps;
// const { Text } = Typography;

// const ApplicationStatusTabForConsumer = ({ activeKey }) => {

//   const [applicationStatusSteps, setApplicationStatusSteps] = useState([]);
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     if (activeKey && activeKey == "1") {
//       getApplicationStatusByApplicationId(Number(localStorage.getItem("ApplicationObjId")));
//     }
//   }, [activeKey]);

//   const getApplicationStatusByApplicationId = async (applicationObjId) => {
//     setLoading(true);
//     try {
//       const res = await _consumerService.getApplicationStatusByApplicationId(Number(applicationObjId));
//       if (res.data) {
//         let resObj = res.data.Obj;
//         setApplicationStatusSteps(resObj);
//         localStorage.setItem("isAllStepsCompleted", JSON.stringify(resObj?.applicationScreenStatus?.IsAllStepsCompleted));
//         localStorage.setItem("IsQuestionairCompleted", JSON.stringify(resObj?.applicationScreenStatus?.IsQuestionairCompleted));
//         setLoading(false);
//       }
//     } catch (e) {
//       console.log(e);
//       setLoading(false);
//     }
//   };

//   // const hasTrueOrFalse = Object.values(applicationStatusSteps && applicationStatusSteps.applicationScreenStatus).some(
//   //   value => value === true || value === false
//   // );

//   return (
//     <Spin spinning={loading}>
//       <ApplicationWorkFlow activeKey={activeKey} applicationStatusSteps={applicationStatusSteps} />
//       <div style={{ borderRadius: 16, padding: 24, overflow: "auto" }} className="stepsColorChange cardViewMain">
//         <Steps
//           current={1}
//           direction="horizontal"
//           labelPlacement="vertical"
//           size="small"
//           style={{ minWidth: "100%" }}
//           className="applicationStatusTimeline"
//           responsive={false}
//         >
//           {applicationStatusSteps?.ListApplicantStatusModel?.map((step, index) => {
//             const isLast = index === applicationStatusSteps.ListApplicantStatusModel.length - 1;
//             const isActionRequired = step.Title === "Action Required" && isLast;

//             return (
//               <Step
//                 key={index}
//                 title={
//                   <div>
//                     <Text
//                       strong
//                       style={{
//                         color: isActionRequired
//                           ? "red"
//                           : step.Status === "wait"
//                             ? "#999"
//                             : "#00E3C4",
//                       }}
//                     >
//                       {step.Title == "Not Qualified" ? "Under Review By Administrator" : step.Title}
//                     </Text>
//                   </div>
//                 }
//                 description={<Text type="secondary">{step.Date}</Text>}
//                 status={isActionRequired ? "error" : "finish"}
//               />
//             );
//           })}
//         </Steps>

//       </div>
//     </Spin>
//   );
// };

// export default ApplicationStatusTabForConsumer;


import React, { useState, useEffect } from "react";
import { Spin, Steps } from "antd";
import { CheckCircleFilled, ClockCircleOutlined, BarChartOutlined, CheckCircleOutlined, InfoCircleOutlined } from '@ant-design/icons';
import "../../../assets/dist/ConsumerProject/Consumer/ConsumerPreview.css";
import _consumerService from "../../../modules/consumerService";
import ApplicationRejectedAlert from "./ApplicationRejectedAlert";

const { Step } = Steps;

const ApplicationStatusTabForConsumer = ({ activeKey }) => {
  const [applicationStatusSteps, setApplicationStatusSteps] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Keep your existing API logic
    if (activeKey && activeKey === "1") {
      getApplicationStatusByApplicationId(Number(localStorage.getItem("ApplicationObjId")));
    }
  }, [activeKey]);

  const getApplicationStatusByApplicationId = async (applicationObjId) => {
    setLoading(true);
    try {
      const res = await _consumerService.getApplicationStatusByApplicationId(Number(applicationObjId));
      if (res.data) {
        setApplicationStatusSteps(res.data.Obj);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  // Icon Logic
  const getStepIcon = (status, index) => {
    const iconStyle = { fontSize: '20px' };
    // Completed / Current Active Step (Green)
    if (status === "finish") return <CheckCircleFilled style={{ ...iconStyle, color: '#448c7e' }} />;

    // Pending Steps (Grey)
    if (index === 1) return <ClockCircleOutlined style={{ ...iconStyle, color: '#F4F4F580' }} />;
    if (index === 2) return <BarChartOutlined style={{ ...iconStyle, color: '#F4F4F580' }} />;
    return <CheckCircleOutlined style={{ ...iconStyle, color: '#F4F4F580' }} />;
  };

  // Mock Data (Matches Screenshot)
  const mockList = [
    { Title: "Draft Created", Date: "7th Jan 2026", Description: "Application created and saved as draft", Status: "finish", IsActive: true },
    { Title: "Submitted", Date: "Pending", Description: "Application submitted for review", Status: "wait", IsActive: false },
    { Title: "Under Review & Assessment", Date: "Pending", Description: "Credit metrics and eligibility assessment", Status: "wait", IsActive: false },
    { Title: "Final Decision", Date: "Pending", Description: "Final approval or rejection decision", Status: "wait", IsActive: false }
  ];

  const stepsToRender = applicationStatusSteps?.ListApplicantStatusModel || mockList;

  return (
    <Spin spinning={loading}>
      <div className="tab-content-container margin5px">
        {["10"].includes(localStorage.getItem("ApplicationStatusId")) && 
      <ApplicationRejectedAlert />
       }
        {/* Header */}
        <div className="timlineMainNewBackgourndVIew">
        <h3 className="timeline-header">Application Timeline</h3>

        {/* Timeline Steps */}
        <div className="timeline-content">
          <Steps
            direction="vertical"
            size="small"
            className="custom-dark-steps"
            current={0} // Controls which step is "in progress" by Antd logic
          >
            {stepsToRender.map((step, index) => (
              <Step
                key={index}
                icon={getStepIcon(step.Status, index)}
                className={step.IsActive || step.Status === 'finish' ? 'step-active' : 'step-inactive'}
                title={
                  <span className="step-title">{step.Title}</span>
                }
                description={
                  <div className="step-details">
                    <div className="step-date">{step.Date}</div>
                    <div className="step-desc">{step.Description}</div>
                  </div>
                }
              />
            ))}
          </Steps>
        </div>
         </div>
      </div>
      {/* Bottom Alert Box (New) */}

      {["8"].includes(localStorage.getItem("ApplicationStatusId")) &&
        <div className="review-alert-box margin5px mt10">
          <div className="alert-icon">
            <InfoCircleOutlined />
          </div>

          <div className="alert-content">
            <div className="alert-title">Review your application</div>
            <div className="alert-desc">
              Please ensure all information is accurate before submitting. Once submitted, you will not be able to edit the application during the review process.
            </div>
          </div>
        </div>
      }
    </Spin>
  );
};

export default ApplicationStatusTabForConsumer;